import {TRecord, TText, TList} from '@packages/systems/wfdl-ast';
import {TJson} from '@packages/systems/plugins/Json';
import {TDateTime} from '@packages/systems/plugins/DateTime';

/**
 * WFDL Type for incoming form data submission, before the data is parsed
 * into a record of form fields.
 */
export const formDataFieldsType = TRecord({
  'Form fields': TList(TRecord({name: TText, value: TJson})),
  Timestamp: TDateTime,
});
